import themeChartHashMap from '../extraUtil/commonChartAttObj';

export default function mergeObj(object, theme) {
   return  Object.assign({}, themeChartHashMap[theme], object);
}


// WEBPACK FOOTER //
// ./src/util/extraUtil/mergeTwoObj.js